import type { IntlShape } from "react-intl";
import { format } from "util";
import {
  BarChart3Icon,
  InfoIcon,
  PanelsTopLeftIcon,
  LineChartIcon,
  MessageCircleIcon,
  SettingsIcon,
  LandmarkIcon,
  UserPenIcon,
  CalendarDaysIcon,
} from "lucide-react";
import { CompanyMenuSlugEnum } from "components/company/v3/menu/enums";
import type { MenuOption } from "components/company/v3/menu/types";
import type { Selfie } from "lib/hooks/useSelfie";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import CompanyNotes from "components/company/v3/CompanyNotes";

export default function getFiisMenus(selfie: Selfie, tickerSymbol: string, intl: IntlShape) {
  const basePath = format("/fiis/%s", tickerSymbol.toLowerCase());

  return [
    {
      slug: CompanyMenuSlugEnum.ABOUT,
      label: intl.formatMessage({
        defaultMessage: "Sobre",
        description: "Item do menu de navegação das empresas",
        id: "p9OPjp",
      }),
      icon: <InfoIcon className="size-5 lg:size-6" />,
      href: format("%s/about", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.CARDS,
      label: intl.formatMessage({
        defaultMessage: "Cards",
        description: "Item do menu de navegação das empresas",
        id: "5wpQkZ",
      }),
      icon: null,
      href: null,
    },
    selfie?.isPremium
      ? {
          slug: CompanyMenuSlugEnum.ASSETS,
          label: intl.formatMessage({
            defaultMessage: "Ativos",
            description: "Item do menu de navegação das empresas",
            id: "P4Lftr",
          }),
          icon: <LandmarkIcon className="size-5 lg:size-6" />,
          href: format("%s/assets", basePath),
        }
      : null,
    selfie?.isPremium
      ? {
          slug: CompanyMenuSlugEnum.LIQUIDITY,
          label: intl.formatMessage({
            defaultMessage: "Liquidez",
            description: "Item do menu de navegação das empresas",
            id: "WGjgSd",
          }),
          icon: <BarChart3Icon className="size-5 lg:size-6" />,
          href: format("%s/liquidity", basePath),
        }
      : null,
    {
      slug: CompanyMenuSlugEnum.EVENTS,
      label: intl.formatMessage({
        defaultMessage: "Eventos",
        description: "Item do menu de navegação das empresas",
        id: "hVbTfJ",
      }),
      icon: <CalendarDaysIcon className="size-5 lg:size-6" />,
      href: format("%s/events", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.QUOTES,
      label: intl.formatMessage({
        defaultMessage: "Cotação",
        description: "Item do menu de navegação das empresas",
        id: "3gozhL",
      }),
      icon: <LineChartIcon className="size-5 lg:size-6" />,
      href: format("%s/quotes", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.FINANCIALS,
      label: intl.formatMessage({
        defaultMessage: "Balanços",
        description: "Item do menu de navegação das empresas",
        id: "bSuut8",
      }),
      icon: <PanelsTopLeftIcon className="size-5 lg:size-6" />,
      href: format("%s/financials", basePath),
    },
    selfie?.isPremium
      ? {
          slug: CompanyMenuSlugEnum.DISCUSSIONS,
          label: intl.formatMessage({
            defaultMessage: "Discussões",
            description: "Item do menu de navegação das empresas",
            id: "6+15gi",
          }),
          icon: <MessageCircleIcon className="size-5 lg:size-6" />,
          href: format("%s/discussions", basePath),
        }
      : null,
    selfie?.isPremium && {
      slug: CompanyMenuSlugEnum.NOTES,
      label: intl.formatMessage({
        defaultMessage: "Anotações",
        description: "Item do menu de navegação das empresas",
        id: "JH1ccU",
      }),
      icon: <UserPenIcon className="size-5 lg:size-6" />,
      href: null,
      render: CompanyNotes,
    },
    selfie && {
      slug: CompanyMenuSlugEnum.SETTINGS,
      label: intl.formatMessage({
        defaultMessage: "Configurações",
        description: "Item do menu de navegação das empresas",
        id: "WUnTuy",
      }),
      icon: <SettingsIcon className="size-5 lg:size-6" />,
      href: format("%s/settings", basePath),
    },
  ].filter(notUndefinedOrNull) as MenuOption[];
}
